module.exports = __webpack_public_path__ + "static/media/the-wizard.ccbd3ae3.jpg";